// extracted by mini-css-extract-plugin
export default {"mainWrap":"EJ7qpN8DVt__uH127nME","t1":"hNzim7jtZ4ntSvgU_8oi","wrapAccounts":"RQpyhBm2dSnBd6pK4q6K","resultWrap":"ByouDrpvAf3feDwapF8e","description":"LS2h0VVfT1aSRmBXU8QA"};